"use client";

import { useCallback } from "react";
import {
  trackEvent,
  trackButtonClick,
  trackNavigationClick,
} from "@/utils/analytics";

export const useAnalytics = () => {
  const trackCustomEvent = useCallback(
    (
      eventName: string,
      eventParameters?: {
        event_category?: string;
        event_label?: string;
        value?: number;
        custom_parameters?: Record<string, string | number>;
      },
    ) => {
      trackEvent(eventName, eventParameters);
    },
    [],
  );

  const trackButton = useCallback(
    (
      buttonText: string,
      buttonLocation: string,
      additionalData?: Record<string, string | number>,
    ) => {
      trackButtonClick(buttonText, buttonLocation, additionalData);
    },
    [],
  );

  const trackNavigation = useCallback(
    (
      linkText: string,
      destination: string,
      linkLocation: string,
      additionalData?: Record<string, string | number>,
    ) => {
      trackNavigationClick(linkText, destination, linkLocation, additionalData);
    },
    [],
  );

  return {
    trackCustomEvent,
    trackButton,
    trackNavigation,
  };
};
